module.exports = __webpack_public_path__ + "img/addClassification.b3f2e0ec.svg";